import React from 'react';
import Icon from '@vtblife/uikit-icons';
import { NavbarMenuItem } from '@vtblife/layout-config/types';
import { NavLink } from 'react-router-dom';

import { IconSmallSize } from '@vtblife/uikit-icons/dist/types';

import styles from './navbar-link.module.css';
import { sendAnalyticsEvent } from '../../../analytics';

interface NavbarLinkProps {
    item: NavbarMenuItem;
}

export const NavbarLink = ({ item }: NavbarLinkProps) => {
    const { href, title, icon, analytics } = item;

    if (!href) {
        return null;
    }

    const clickHandler = () => {
        analytics && sendAnalyticsEvent(analytics);
    };

    return (
        <NavLink to={href} className={styles.link} activeClassName={styles.active} onClick={clickHandler} exact>
            <span className={styles.icon}>
                <Icon name={icon as IconSmallSize} />
            </span>
            <span>{title}</span>
        </NavLink>
    );
};
